import React from 'react';
import { useTranslation } from 'react-i18next';
import { useIsReadOnly } from '../../hooks/useIsReadOnly';

interface OfferFormActionsProps {
  onGenerate: () => void;
  isGenerating: boolean;
  onSaveDraft: () => void;
  onGeneratePreview: () => void;
  isSavingDraft: boolean;
  isGeneratingPreview: boolean;
}

const OfferFormActions: React.FC<OfferFormActionsProps> = ({ 
  onGenerate,
  isGenerating,
  onSaveDraft,
  onGeneratePreview,
  isSavingDraft,
  isGeneratingPreview
}) => {
  const { t } = useTranslation('offer');
  // M11b-3: advisor (read-only) darf keine Angebote erstellen/speichern — Aktionsleiste entfällt.
  const isReadOnly = useIsReadOnly();
  const isAnyActionLoading = isGenerating || isSavingDraft || isGeneratingPreview;

  if (isReadOnly) {
    return null;
  }

  return (
    <div className="mt-8 pt-5 border-t border-hairline">
      <div className="flex flex-col sm:flex-row justify-between gap-4">
        {/* Draft-Aktionen Links */}
        <div className="flex flex-col sm:flex-row gap-2">
          <button
            type="button"
            onClick={onSaveDraft}
            disabled={isAnyActionLoading}
            className={`px-4 py-2 border border-gray-500 rounded-md shadow-sm text-sm font-medium text-secondary bg-surface-inset hover:bg-surface-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 focus:ring-offset-gray-800 ${isAnyActionLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            {isSavingDraft ? (
              <>
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-secondary inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
{t('common:loading', { ns: 'common' })}...
              </>
            ) : (
              t('actions.saveAsDraft')
            )}
          </button>
          
          <button
            type="button"
            onClick={onGeneratePreview}
            disabled={isAnyActionLoading}
            className={`px-4 py-2 border border-yellow-500 rounded-md shadow-sm text-sm font-medium text-[var(--tone-warning-fg)] bg-[var(--tone-warning-bg)] hover:brightness-110 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 focus:ring-offset-gray-800 ${isAnyActionLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            {isGeneratingPreview ? (
              <>
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-[var(--tone-warning-fg)] inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
{t('common:loading', { ns: 'common' })}...
              </>
            ) : (
              t('actions.generatePreview')
            )}
          </button>
        </div>

        {/* Finales Angebot Rechts */}
        <div className="flex justify-end">
          <button
            type="button"
            onClick={onGenerate}
            disabled={isAnyActionLoading}
            className={`px-6 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-[#0C1322] bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 focus:ring-offset-gray-800 ${isAnyActionLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            {isGenerating ? (
              <>
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-primary inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
{t('common:loading', { ns: 'common' })}...
              </>
            ) : (
              t('actions.generateOffer')
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OfferFormActions; 